import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  return {
    getAccountLimits: `${baseURL}/api/account/limits`,
    getUserSetting: (idList, dataKey) =>
      `${baseURL}/api/usersettings/list/${encodeURIComponent(
        idList
      )}/${encodeURIComponent(dataKey)}`,
    upsertUserSettings: (idList, dataKey) =>
      `${baseURL}/api/usersettings/list/${encodeURIComponent(
        idList
      )}/${encodeURIComponent(dataKey)}`,
    notifyQeueuing: `${baseURL}/api/adm/notifyevent/queuing`,
    listUsers: (params) => `${baseURL}/api/users?${encodeParams(params)}`,
    getUser: (idUser) => `${baseURL}/api/users/${idUser}`
  }
})(process.env.BEACCOUNTSETTINGS_URL)

export const beAccountSettimgsApiGetAccountLimits = () => {
  const url = endpoints.getAccountLimits
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beAccountSettingsGetUserSetting = (idList, dataKey) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getUserSetting(idList, dataKey)
  }).then(({ data }) => data)
}

export const beAccountSettingsUpsertUserSettings = (
  idList,
  dataKey,
  DataValue
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.upsertUserSettings(idList, dataKey),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({ DataValue: JSON.stringify(DataValue) })
  }).then(({ data }) => data)
}

export const beAccountSettingsNotifyQueueing = (data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.notifyQeueuing,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(({ data }) => data)
}

export const beAccountSettingsPostUserSettings = (
  idList,
  dataKey,
  dataValue
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getUserSetting(idList, dataKey),
    headers: {
      'Content-Type': 'application/json'
    },
    data: { DataValue: JSON.stringify({ addresses: dataValue.join(';') }) }
  }).then(({ data }) => data)
}

export const beAccountListUsers = (params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.listUsers(params)
  }).then(({ data }) => data)
}

export const beAccountSettingsApiGetUser = async (idUser) => {
  const url = endpoints.getUser(idUser)

  return await apiWrapper({
    method: 'get',
    url
  }).then(({ data }) => data)
}
